import $ from 'domtastic';

class Box {
  constructor() {
    if (!$('.js-box')[0]) return;
    this.cacheDom();
    this.findMultilines();
  }

  cacheDom() {
    this.$wrapper = $('.js-box');
  }

  findMultilines() {
    this.$wrapper.forEach((box) => {
      const $box = $(box);
      const $title = $box.find('.box__title');
      const height = $title[0].offsetHeight;
      if (height > 28) $box.addClass('-multiline');
    });
  }
}

export default new Box();



// WEBPACK FOOTER //
// ./components/Box.js